<template>

        <v-row>
            <v-col cols="12">
                <div class="headline">Orte</div>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs6>
                                        {{ editedItem.city }}
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field v-model="editedItem.name" label="Ortsteil"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="close">Abbrechen</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="save">Speichern</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="far fa-search"
                                label="Suchen"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="tables.cities.header"
                            :items="districts"
                            :search="search"
                            class="mb-4"
                            no-data-text="Keine Orte vorhanden"
                            :items-per-page="15"
                    >
                      <template v-slot:item.tourTemplate="{ item }">
                        <v-btn class="mr-2" depressed fab small color="accent" v-for="tour in item.tourIdentifier" :key="tour">{{ tour }}</v-btn>
                      </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

</template>

<script>

export default {
  name: 'Districts',
  computed: {
    cities () {
      return this.$store.state.cities.all
    },
    districts () {
      return this.$store.state.districts.all
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Neuer Ortsteil' : 'Ortsteil bearbeiten'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  data: () => ({
    dialog: false,
    editedIndex: -1,
    editedItem: {
      id: 0,
      city: 0,
      name: ''
    },
    defaultItem: {
      id: 0,
      city: 0,
      name: ''
    },
    search: '',
    tables: {
      cities: {
        header: [
          {text: 'Ort', value: 'cityName'},
          {text: 'Ortsteil', value: 'name'},
          {text: 'Touren', value: 'tourTemplate'}
        ]
      }
    }
  }),
  methods: {
    editItem (item) {
      this.editedIndex = this.districts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.city = this.getCity(item.city).name
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
    },
    save () {
      this.$store.commit('updateDistrict', {index: this.editedIndex, item: this.editedItem})
      this.close()
    },
    getCity (id) {
      return this.$store.state.cities.all.find(element => element.id === id)
    },
    getCityByDistrict (id) {
      return this.$store.state.cities.all.find(element => element.district === id)
    },
    getDistrict (id) {
      return this.$store.state.districts.all.find(element => element.id === id)
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/Districts.vue